import { render, staticRenderFns } from "./text-input.vue?vue&type=template&id=48f79f06"
import script from "./text-input.vue?vue&type=script&lang=js"
export * from "./text-input.vue?vue&type=script&lang=js"
import style0 from "./text-input.vue?vue&type=style&index=0&id=48f79f06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports